import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import { logout } from "../../../actions/authentication/authentication";
import ActionMenu from "../../sub/ActionMenu";
import Roles from "../../../enums/Roles";
import { Alert, Modal } from "react-bootstrap";
import { deleteCompanyNotifAdmin } from "../../../actions/company/company";
import MenuButton from "../../../components/sub/bootstrap/MenuButton";
import Util from "../../../util/Util";
import Changelog from "../../changelog/changelog";

class DropdownMenuProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      notifrender: null,
      notificationModal: null,
      modal: null,
    };
  }

  closeModal = () => {
    this.setState({ modal: null });
  };

  openChangelogModal() {
    this.setState({
      modal: <Changelog close={() => this.closeModal()} />,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.company !== prevProps.company) {
      if (
        this.props.company &&
        this.props.company.notif &&
        (this.props.user.role === Roles.ADMIN ||
          this.props.user.role === Roles.SALES_REP)
      ) {
        this.setState({
          notificationModal: (
            <Modal show={true} backdrop="static" keyboard={false} size="lg">
              <Modal.Header>
                <Modal.Title>
                  <FormattedMessage id="Warning" />s
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Alert variant="warning">
                  <FormattedMessage id="Warning.Detect.Notice" />
                </Alert>
                <table className="table tablee4mad">
                  <thead>
                    <tr className="d-flex align-items-center">
                      <th scope="col" className="col">
                        <FormattedMessage id="Module" />
                      </th>
                      <th scope="col" className="col-8">
                        <FormattedMessage id="Error.Detail" />
                      </th>
                      <th scope="col" className="col-2 text-end">
                        <FormattedMessage id="Actions" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.company.notif.map((notif, index) => {
                      return (
                        <tr key={index} className="d-flex align-items-center">
                          <td className="align-middle">
                            {notif.type === "crm"
                              ? this.props.company.crm.software
                              : notif.type}
                          </td>
                          <td className="col-8 text-break">{notif.msg}</td>
                          <td className="col-2 text-end">
                            <MenuButton
                              icon="trash"
                              onClick={() =>
                                this.props.onDeleteCompanyNotifAdmin(
                                  { index: index },
                                  () => this.displayNotificationModal(false),
                                )
                              }
                              variant="danger"
                              hover={<FormattedMessage id="Delete" />}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Modal.Body>

              <Modal.Footer>
                <MenuButton
                  variant="secondary"
                  onClick={() => this.displayNotificationModal(false)}
                >
                  <FormattedMessage id="Close" />
                </MenuButton>
              </Modal.Footer>
            </Modal>
          ),
        });
      }
    }
  }

  logout(e) {
    e.preventDefault();
    e.stopPropagation();

    let that = this;
    function onLogoutSuccess() {
      that.props.history.push("/");
    }

    // Call logout and redirect on success
    this.props.onLogout(onLogoutSuccess);
  }

  displayNotificationModal(dialogState) {
    this.setState({
      //displayModal: !this.state.displayModal,
      modal: dialogState ? this.state.notificationModal : null,
    });
  }

  render() {
    let menuItems = [];

    const isSupervisor = this.props.user.supervisor_id ? true : false;

    if (this.props.company.notif?.length) {
      menuItems.push({
        icon: "exclamation-triangle",
        action: () => this.displayNotificationModal(true),
        text: (
          <>
            <FormattedMessage id="Warning" />
            (s)
          </>
        ),
        notification: this.props.company.notif.length,
        variant: "danger",
      });
    }

    !isSupervisor &&
      menuItems.push({
        icon: "pen-to-square",
        href: "#/home/account",
        text: <FormattedMessage id="My.Account" />,
      });

    menuItems.push({
      icon: "circle-info",
      action: () => this.openChangelogModal(),
      disabled: this.props.user.role === Roles.CLIENT && true,
      text: "v" + process.env.REACT_APP_VERSION,
    });

    menuItems.push({
      icon: "power-off",
      action: (e) => this.logout(e),
      text: <FormattedMessage id="Disconnect" />,
    });

    const menuAction = (
      <ActionMenu
        items={menuItems}
        icon={
          this.props.company.notif?.length ? "exclamation-triangle" : "user"
        }
        variant={this.props.company.notif?.length && "danger"}
        size="xl"
        header={!isSupervisor && Util.formatFullName(
          this.props.user.first_name,
          this.props.user.name,
        )}
      />
    );

    return (
      <React.Fragment>
        {menuAction}
        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (successCallback) => dispatch(logout(successCallback)),
    onDeleteCompanyNotifAdmin: (data, successCallback) =>
      dispatch(deleteCompanyNotifAdmin(data, successCallback)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DropdownMenuProfile),
);
